module.exports = __webpack_public_path__ + "img/logo-icon.d33e63a4.png";